export default "__VITE_ASSET__CAhvH7iF__"